import { ApiUserAuthToken } from './types'
import { UserAuthToken } from '~/models/AuthToken'
import TokenService from '~/passporter-services/shared/token'

export class AuthEntityMapper {
	static obtainTokenInfo(data: ApiUserAuthToken): UserAuthToken {
		const { access, refresh } = data
		const token = TokenService.getTokenInfo(access!.split('.')[1])
		return { access, refresh, id: token.id!, exp: token.exp }
	}
}
